var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13518 1.66513L5.04464 0.882131C4.82798 0.80231 4.47449 0.80231 4.25783 0.882131L2.16729 1.66513C1.76438 1.81717 1.4375 2.2885 1.4375 2.71801V5.79681C1.4375 6.10469 1.63895 6.51139 1.88602 6.69384L3.97656 8.25604C4.34525 8.53352 4.94961 8.53352 5.31831 8.25604L7.40885 6.69384C7.65591 6.50759 7.85737 6.10469 7.85737 5.79681V2.71801C7.86117 2.2885 7.53428 1.81717 7.13518 1.66513ZM5.97208 3.79369L4.33765 5.42811C4.28064 5.48513 4.20842 5.51173 4.1362 5.51173C4.06398 5.51173 3.99176 5.48513 3.93475 5.42811L3.32659 4.81235C3.21636 4.70212 3.21636 4.51968 3.32659 4.40945C3.43682 4.29922 3.61927 4.29922 3.72949 4.40945L4.14 4.81995L5.57297 3.38698C5.6832 3.27675 5.86565 3.27675 5.97588 3.38698C6.08611 3.49721 6.08611 3.68346 5.97208 3.79369Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/Secure.c1290a6ed40baf85a78cb1f4b29bff55.svg";
export { ForwardRef as ReactComponent };